import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { Row, Col, Button } from "react-bootstrap";

import ButtonCell from "../common/button_cell";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";

import TableSortLabel from "@mui/material/TableSortLabel";

import TextField from "@mui/material/TextField";

import CircularProgress from "@mui/material/CircularProgress";

import { Checkbox, Tooltip } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  makeid,
  IsAdmin,
  IsOrder,
  IsAuthorize,
} from "../../helpers/helper_methods";
import moment from "moment/moment";

import pink from "@mui/material/colors/pink";

import { arrayFilter } from "../../helpers/helper_methods";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";

import UserContext from "../../context/user_context";

import RegistryTableHeader from "./registry_table_components/table_header";
import RegistryTableBody from "./registry_table_components/table_body";

export function RegistryTable(props) {
  const {
    registry_columns,
    fullTable,
    patientData,
    selectedPatient,
    setSelectedPatient,
    loading,
    registry,
    registries,
    location,
    patientView,
    showModal,
    setShowModal,
    selectedEpisode,
    setSelectedEpisode,
    page,
    setPage,
    order,
    setOrder,
    rowsPerPage,
    setRowsPerPage,
    orderBy,
    setOrderBy,
    totalRecords,
    filterText,
    setFilterText,
    highCriticality,
    cart,
    setCart,
    handleSetCart,
    handleSetRow,
    physician,
    setDocument,
    setCustomSort,
  } = props;

  const [reset, setReset] = useState(false);

  const [selected, setSelected] = useState(
    localStorage.getItem("selected") != undefined
      ? JSON.parse(localStorage.getItem("selected"))
      : []
  );

  const handleRequestSort = (event, property) => {
    if (typeof property === "string") {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
      setCustomSort(null);
    } else {
      const isAsc = orderBy === property.column && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property.column);
      setCustomSort(property.sort_type);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  //
  //#region Checkbox logic section
  //
  const [checked, setChecked] = React.useState([]);

  // Defaults the checked variable on load based on localstorage
  useEffect(() => {
    var tempChecked = [];

    patientData.map((patient) => {
      tempChecked.push(false);
    });

    setChecked(tempChecked);
  }, []);

  //#endregion

  function handleSelectAllClick(event) {
    if (!event.target.checked) {
      var newCart = [];

      cart.map((ci) => {
        if (
          patientData.findIndex(
            (x) => x.patient.id == ci.patient.id && x.registry.id == registry.id
          ) == -1
        ) {
          newCart.push(ci);
        }
      });

      setCart(newCart);
      localStorage.removeItem(`${registry.id}`);
    } else {
      var abstractCart = Object.assign([], cart);

      patientData.map((rowData, index) => {
        rowData.episode.orderable_tests.map((ot) => {
          if (
            ot.currently_orderable &&
            cart.findIndex((x) => x.testCode == ot.id) == -1
          ) {
            abstractCart.push({
              registry: registry,
              testCode: ot.id,
              patientId: rowData.patient.id,
              patient: rowData.patient,
              test: ot,
              physician: physician,
              location: location,
              icd_codes: [],
            });
          }
        });
      });
      setCart(abstractCart);
    }

    setReset(() => !reset);
  }

  const isSelected = (row) => {
    var allSelected = true;

    if (row.episode.orderable_tests != null) {
      row.episode.orderable_tests.map((ot) => {
        if (
          cart.findIndex((x) => x.orderable_test_id == ot.id) == -1 &&
          ot.currently_orderable
        ) {
          allSelected = false;
        }
      });
    }

    return allSelected;
  };

  const isRowSelected = (row) => {
    if (
      selectedPatient.episode != undefined &&
      selectedPatient.episode.id == row.episode.id &&
      !fullTable
    ) {
      return true;
    } else {
      return false;
    }
  };

  function handleRowCheck(event, name, rowData) {
    var rowToHandle = [];

    if (!event.target.checked) {
      localStorage.removeItem(registry.id);
    }

    if (rowData.episode.orderable_tests != null) {
      rowData.episode.orderable_tests.map((ot) => {
        if (ot.currently_orderable) {
          rowToHandle.push({
            physician: rowData.physician,
            patient: rowData.patient,
            orderableTest: ot,
            toAdd: event.target.checked,
          });
        }
      });
    }

    handleSetRow(rowToHandle);
  }

  var childrenProps = {
    patientData,
    selected,
    isSelected,
    isRowSelected,
    setSelected,
    fullTable,
    setSelectedPatient,
    rowsPerPage,
    page: page,
    handleRowCheck,
    registry,
    registries,
    registry_columns,
    cart,
    handleSetCart,
    handleSelectAllClick,
    order,
    orderBy,
    onRequestSort: handleRequestSort,
    filterText,
    setFilterText,
    arrayFilter,
    location,
    patientView,
    showModal,
    setShowModal,
    selectedEpisode,
    setSelectedEpisode,
    physician,
    highCriticality,
    setDocument,
  };

  return (
    <>
      <TableContainer>
        <TextField
          id="outlined-required"
          label="Search..."
          className={`table-text-box`}
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          variant="standard"
        />
        {loading ? (
          <>
            <CircularProgress />
          </>
        ) : null}
        <Table aria-label={`Registry Table`}>
          <RegistryTableHeader {...childrenProps} />
          <RegistryTableBody {...childrenProps} />
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={totalRecords}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        showFirstButton
        showLastButton
      />
    </>
  );
}

RegistryTable.propTypes = {
  registries: PropTypes.array.isRequired,
  patientData: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  fullTable: PropTypes.bool.isRequired,
  registry_columns: PropTypes.array.isRequired,
  selectedPatient: PropTypes.object,
  setSelectedPatient: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  registry: PropTypes.object.isRequired,
};

RegistryTable.defaultProps = {
  registries: [],
  activeTab: "",
  patientData: [],
  columns: [],
  fullTable: true,
  loading: false,
};
